import React from 'react';
import { DateInput, Select, InputNumber } from '../../Common';
import {
    Grid,
    FormControl,
    FormControlLabel,
    FormLabel,
    RadioGroup,
    Radio,
} from '@mui/material';

const LeakFields = ({
    isChecked,
    disabled,
    wasLeakFound,
    inspectionDate,
    leakLocationId,
    leakSublocationId,
    faultCauseTypeId,
    estimatedLeakAmount,
    onLeakFound,
    onFieldChange,
    dropDownOptions
}) => (
    <>
        <Grid item xs={12}>
            <FormControl required sx={{ fontSize: "14px" }} disabled={disabled || !isChecked}>
                <FormLabel sx={{ fontSize: "14px", mb: 1 }}>Was Leak Found?</FormLabel>
                <RadioGroup
                    row
                    onChange={e => onLeakFound(e.target.value === "true")}
                    value={wasLeakFound}
                    aria-labelledby="row-radio-buttons-group-label"
                    sx={{ ml: 2 }}
                >
                    <FormControlLabel value={"true"} control={<Radio />} label="Yes" />
                    <FormControlLabel value={"false"} control={<Radio />} label="No" />
                </RadioGroup>
            </FormControl>
        </Grid>
        {wasLeakFound && (
            <>
                <Grid item xs={12} md={4}>
                    <DateInput
                        variant="outlined"
                        allowPast={true}
                        allowFuture={false}
                        label="Date Leak Found*"
                        date={inspectionDate}
                        onChange={new_date => onFieldChange("inspectionDate", new_date)}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Select
                        required
                        variant="outlined"
                        label="Leak Location"
                        value={leakLocationId}
                        onChange={e => onFieldChange("leakLocationId", e.target.value)}
                        options={dropDownOptions.leakLocationCategories}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Select
                        required
                        variant="outlined"
                        label="Leak Sub-Location"
                        value={leakSublocationId}
                        disabled={!leakLocationId}
                        onChange={e => onFieldChange("leakSublocationId", e.target.value)}
                        options={dropDownOptions.leakLocations.filter(x => x.category === leakLocationId)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Select
                        required
                        variant="outlined"
                        label="Leak Cause"
                        value={faultCauseTypeId}
                        onChange={e => onFieldChange("faultCauseTypeId", e.target.value)}
                        options={dropDownOptions.leakCauses}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <InputNumber
                        fullWidth
                        hideStepper
                        label="Estimated Leak Amount"
                        variant="outlined"
                        value={estimatedLeakAmount}
                        onChange={e => onFieldChange("estimatedLeakAmount", e.target.value)}
                    />
                </Grid>
            </>
        )}
    </>
);

export default LeakFields;
